import { isEmpty } from 'lodash';
import { ATTACHMENTS_SECTION_TITLE, BriefSection, SectionTypes } from '@fiverr-private/ai_brief';

import { appTranslate } from '../../../i18n';

export const getAttachmentsSection = (): BriefSection => ({
  id: ATTACHMENTS_SECTION_TITLE,
  included: false,
  title: appTranslate('sections.attachments').toString(),
  content: '',
  type: SectionTypes.attachments,
  customValidator: (section) => !isEmpty(section.attachments),
});
